export const MONTHLY_PERIODICITY = "MONTHLY"
export const YEARLY_PERIODICITY = "YEARLY"

export const SUBSCRIPTION_STATUS_ACTIVE = "active"
export const SUBSCRIPTION_STATUS_TRIALING = "trialing"
export const SUBSCRIPTION_STATUS_CANCELLED = "cancelled"
export const SUBSCRIPTION_STATUS_INCOMPLETE = "incomplete"

export const ACTIVE_SUBSCRIPTION_TYPES = [
  SUBSCRIPTION_STATUS_ACTIVE,
  SUBSCRIPTION_STATUS_TRIALING,
]
